<template>
    <!-- 退会パーツ -->
    <div class="pt420" id="pt420" v-cloak>
        <breadcrumb :navListCustom="[{title:$t('common.labels.myPgage'), routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title:$t('pt420.labels.title1'), routerName: '', param: {}}]"></breadcrumb>
        <div class="section">
            <div class="itemTitle">
                <h2>{{$t('common.labels.myPgage')}}</h2>
            </div>
            <!-- 退会前 -->
            <div class="sectionInner" v-if="pageType == 3">
                <h3 class="memberQuitTitle">{{$t('pt420.labels.title1')}}</h3>
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="pt420_PART"/>
                <div class="messaggeContainer">
                    <p class="explainMessagge">
                        {{$t('pt420.labels.msg1')}}<br>
                        {{$t('pt420.labels.msg2')}}<br>
                        {{$t('pt420.labels.msg3')}}
                    </p>
                </div>
                <div class="kakuninMessage">
                    <p>{{$t('pt420.labels.msg4')}}</p>
                    <ul class="kakuninDetail">
                        <li>{{$t('pt420.labels.msg5')}}</li>
                    </ul>
                </div>
                <span id="memo_lbl" class="lblMemo">{{$t('pt420.labels.memo')}}</span>
                <input-check v-model="pt420Request.memo" rows="5" cols="70" :classify="'textarea'" class="multi memo" name="memo" type="text" />

                <div class="footerButton">
                    <!--戻るボタン-->
                    <div id="btn_roll3" v-if="pt420Init.backButtonFlg == 1">
                        <a class="btnBack"  @click="backUrl()">{{$t('common.buttons.return')}}</a>
                    </div>
                    <div id="btn_roll2">
                        <a class="btnDanger"  @click="confirmDoDelete">{{$t('pt420.buttons.doDelete')}}</a>
                    </div>
                </div>

            </div>
            <!-- 退会完了後 -->
            <div class="sectionInner" v-else>
                <div>
                    <h3 class="memberQuitTitle">{{$t('pt420.labels.title2')}}</h3>
                    <p class="finishedMsg">{{$t('pt420.labels.msg7')}}</p>
                    <p>
                        {{$t('pt420.labels.msg8')}}<br>
                        {{$t('pt420.labels.msg9')}}
                    </p>
                </div>
            </div>
            <!-- modal confirm area -->
            <alert-confirm 
                v-if="isModalShow"
                id="pt420alertConfirm"
                :msgConfirm="msgConfirm"
                :okAction="doAction"
                :isButtonCancel="isButtonCancel">
            </alert-confirm>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import DataTable from 'components/Datatable';
import common from 'assets/js/common';
import BackButton from 'components/BackButton';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import Loading from 'vue-loading-overlay';
import InputCheck from 'components/InputCheck.vue';
import DownloadFile from 'components/DownloadFile';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /*
    * Name of component
    */
    name: "pt420MemberInfoParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /*
    * Declare components
    */
    components: {
        DataTable,
        BackButton,
        Message: Message,
        Loading,
        InputCheck,
        DownloadFile,
        AlertConfirm,
        InputNumber,
        Breadcrumb
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            pt420_PART: 'pt420',
            isLoading: false,
            isDisplay: false,
            pt420Init: {},
            pt420Request: {},
            isButtonCancel: true,
            actionFlg:0,
            listIdErr:[],
            SiteConstants: SiteConstants,
            pageType:3,
            isModalShow:false,
            msgConfirm:'',
            listMessValid:[],
            mapMessValid:[],
            report:'',
            isButtonOK:false,
            site: ""
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt420Init = _this.ptInitData;
            _this.pt420Request = Object.assign({}, _this.pt420Request, _this.ptInitData.reqModel);
            if(_this.pt420Init.isLogin == true){
                _this.pageType = 3;
            }else{
                _this.pageType = 4;
            }

            if(_this.ptInitData.errList != null && _this.ptInitData.errList.length > 0){
                _this.displayWarning(_this.ptInitData.errList);
            }
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT420 + _this.$UrlConstants.DO_INIT,_this.pt420Request).then(function(response) {
                _this.pt420Init = response.data;
                _this.pt420Request = Object.assign({}, _this.pt420Request, response.data.reqModel);
                if(_this.pt420Init.isLogin == true){
                    _this.pageType = 3;
                }else{
                    _this.pageType = 4;
                }

                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWarning(response.data.errList);
                }

            }).catch(function(error) {
                common.errorAPI(error);
            });
        }

        //close pupup
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        confirmDoDelete: function(){
            if (this.ptInitData.teikiOderNum > 0) {
                this.msgConfirm = this.$i18n.t('pt420.labels.msg10');
            } else {
                this.msgConfirm = this.$i18n.t('pt420.labels.msg6');
            }
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 1;
        },

        /*
        *  add new tdk
        */
        doDelete: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            _this.report = '';
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.pt420_PART);
            //common.clearMessageEcSite(_this.listIdErr,'pt010');
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT420 + _this.$UrlConstants.DO_DELETE, _this.pt420Request).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pt420Init.isLogin = false;
                    _this.pageType = 4;
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 11, pageType: _this.pageType}});
                }
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", !true);
            }).catch(function(error) {
                _this.$emit("event-loading", !true);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.pt420_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            // マイメニュー画面へ遷移
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
        },
         /*
        *  execute update or delete or insert
        */
        doAction: function(){
            var _this = this;
            switch (this.actionFlg) {
                case 1:
                    this.doDelete();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            this.isModalShow = false;
            this.actionFlg = 0;
            this.isButtonCancel = true;
        },
        /* 
        * Function excuteValidation 
        * analyst data message and display
        */
        displayWarning(errorList){
            var idList  = [];
            var mapMsg = [];
            var msgList = [];
            var listIdErr = [];
            // check error list
            if(errorList != null && errorList.length > 0){
                //var errorList = error.response.data.errorList;
                for(var index =0;  index < errorList.length; index ++){
                    // row of table
                    var rowTableIndex = errorList[index].rowTableIndex == undefined ? -1 : errorList[index].rowTableIndex;
                    // zoneIndex
                    var zoneIndex = errorList[index].zoneIndex == undefined ? -1 : errorList[index].zoneIndex;

                    // set border-color for input
                    var listGroupId = errorList[index].groupId;
                    if(listGroupId != null && listGroupId.length > 0){
                        for (var keyInx = 0; keyInx < listGroupId.length; keyInx++){
                            var idInput = listGroupId[keyInx];
                            var inputObj = $('#' + idInput);
                            if(inputObj != null && inputObj != undefined){
                                inputObj.css('border-color', "red");
                            }

                            listIdErr.push(idInput);
                        }
                    }

                    // replace messenge
                    var messageList = errorList[index].messageList;
                    if(messageList != null && messageList.length > 0){
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++){
                            var msgTemp = messageList[mesInx].message;
                            var argList =messageList[mesInx].argList;
                            if(argList != null && argList.length > 0){
                                
                                for(var arg=0; arg<argList.length; arg++){
                                    // get lable display of item input 
                                    var idInput = $('#'+ argList[arg] + '_lbl');
                                    var label ='';

                                    if(idInput != null && idInput != undefined){
                                        label =  idInput.text();
                                    }
                                    // replace text for key to display
                                    if(rowTableIndex > -1){
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label).replace('{rowIndex}', rowTableIndex);   
                                        }else{
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }else{
                                        if(label.length > 0){
                                            msgTemp = msgTemp.replace('{' + argList[arg] + '}', label);   
                                        }
                                    }
                                }
                            }
                            // if message not include key(message common)
                            if(listGroupId != null && listGroupId.length > 0){
                                var obj ={};
                                obj.key = listGroupId[0];
                                obj.mess= msgTemp;
                                mapMsg.push(obj);
                            }else{
                                msgList.push(msgTemp);
                            }
                            
                        }
                    }
                }

                // emit message to componet message
                var msg ={};
                msg.listMess = msgList;
                msg.mapMsg = mapMsg;
                EventBus.$emit('message', msg);
                return listIdErr;
            }
        }
    }
}
</script>
